'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _veIcons = require('@ali/ve-icons');

var _veIcons2 = _interopRequireDefault(_veIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Message = (_temp = _class = function (_Component) {
  _inherits(Message, _Component);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Message.prototype.componentWillMount = function componentWillMount() {
    this.handle = this.props.handle;
  };

  Message.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var popup = this.shell;

    var _props = this.props,
        type = _props.type,
        duration = _props.duration;
    var animation = this.props.animation;


    if (animation) {
      // prepare
      if (type === 'error' && animation === true) {
        animation = 'shake';
      }

      if (animation === 'appear') {
        popup.classList.add('ve-ani-appear');
      } else if (animation === 'shake') {
        popup.classList.add('ve-ani-shake');
      } else {
        // appear
        popup.classList.add('ve-ani-scale');
      }

      // animate
      this.timer = setTimeout(function () {
        if (animation === 'shake') {
          popup.classList.add('ve-visible-shake');
        } else {
          popup.classList.add('ve-visible');
        }
      }, 10);
    } else {
      popup.classList.add('ve-visible');
    }

    if (duration) {
      var timer = setTimeout(function () {
        _this2.handle.close();
      }, duration);
      this.willDetach = function () {
        clearTimeout(timer);
      };
    }
  };

  Message.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Message.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.willDetach) {
      this.willDetach();
    }
    this.clearTimer();
  };

  Message.prototype.clearTimer = function clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  Message.prototype.render = function render() {
    var _this3 = this;

    var className = (0, _classnames2.default)('ve-message', this.props.className);
    var type = this.props.type;

    return _react2.default.createElement(
      'div',
      { className: className, ref: function ref(_ref) {
          _this3.shell = _ref;
        }, style: this.props.style },
      _react2.default.createElement(
        'a',
        { className: 've-message-close', onClick: function onClick() {
            return _this3.handle.close();
          } },
        _react2.default.createElement(_veIcons2.default, { name: 'close', size: '14px' })
      ),
      _react2.default.createElement(_veIcons2.default, { name: type, size: 'large', className: 've-message-icon-' + type }),
      _react2.default.createElement(
        'div',
        { className: 've-message-content' },
        this.props.content
      )
    );
  };

  return Message;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  type: _react.PropTypes.oneOf(['info', 'error', 'success', 'warn']),
  style: _react.PropTypes.object,
  animation: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['appear', 'scale', 'shake']), _react.PropTypes.bool]),
  content: _react.PropTypes.node,
  duration: _react.PropTypes.number,
  handle: _react.PropTypes.object.isRequired
}, _class.defaultProps = {
  animation: true,
  type: 'info',
  style: null,
  className: null,
  duration: 3000
}, _class.displayName = 'Message', _temp);
exports.default = Message;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/message.js
// module id = 288
// module chunks = 0